
<template>
	<div class="cursor-pointer">
		<div
			v-if="
				onePs.urls_displayed == 'loading' ||
				onePs.google_indexable_urls == 'loading'
			"
		>
			<div class="sloader"></div>
		</div>
		<div v-else>
			{{
				Number(onePs.google_indexable_urls) == 0 ||
				Number(onePs.urls_displayed) == 0
					? 0
					: Math.floor(
							(Number(onePs.google_indexable_urls) /
								Number(onePs.urls_displayed)) *
								100
					  ) || 0
			}}
			%
		</div>
	</div>
</template>
  
  <script>
export default {
	data() {
		return {
			onePs: {},
		};
	},
	created() {
		this.onePs = this.params.data;
	},
};
</script>
  
  <style scoped>
/* Optional styling */
</style>